import React from 'react';
import Client from 'containers/app/client';
import { Col } from 'antd';
import { useDocument } from 'react-firebase-hooks/firestore';
import { useUserWithRole } from 'hooks/custom-auth';
import { ROUTE_EMPLOYER_PREFIX } from 'utils/routes';
import { NavLink } from 'react-router-dom';

const Tokens = () => {
  const ref = Client.dbProfile();
  const [user, loadingUser, errorUser] = useUserWithRole(Client.auth);
  const [profile, loadingProfile, errorProfile] = useDocument(ref);

  if (loadingUser || loadingProfile) return null;
  if (errorUser || errorProfile) return null;
  if (!user) return null;
  if (user.claims.role !== 'isEmployer') return null;

  // console.log("profile.data()", profile.data());
  if (!profile || !profile.data()) return null;

  const { tokens = 0, isProfileComplete = false } = profile.data();

  if (!isProfileComplete) return null;
  
  return (
    <Col key="tokens" className="navlinks">
      <NavLink to={`${ROUTE_EMPLOYER_PREFIX}/buy-tokens`}>
        Buy tokens {tokens > 0 ? tokens : ''}
      </NavLink>
    </Col>
    // <Button href={`${ROUTE_EMPLOYER_PREFIX}/buy-tokens`}>
    //   Buy tokens {tokens > 0 ? tokens : ''}
    // </Button>
  );
};

export default Tokens;
